<template>
    <div class="h-screen bg-white">
        <div class="w-full">
            <div class="flex">
                <div class="w-full flex flex-col">
                    <div class="w-full flex flex-wrap">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
